import React, { useState } from "react";
import {
  markProductVariantBestSeller,
  markProductVariantNotaBestSeller,
} from "../../../services/productVariantService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const ProductVariantBestSellerToggleSwitch = ({
  propId,
  initialStatus,
  onStatusChange,
}) => {
  const [isFeatured, setisFeatured] = useState(initialStatus === "Best-Seller");

  const handleToggle = async () => {
    const newStatus = isFeatured ? "Not-a-Best-Seller" : "Best-Seller";
    const modalTitle = isFeatured
      ? "Mark Product Variant Best Seller"
      : "Mark Product Variant Not a Best Seller";
    const modalMessage = isFeatured
      ? "Are you sure you want to mark this product variant not a best seller?"
      : "Are you sure you want to mark this product variant a best seller?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isFeatured) {
          await markProductVariantNotaBestSeller(propId, newStatus);
        } else {
          await markProductVariantBestSeller(propId, newStatus);
        }
        setisFeatured(!isFeatured);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The product variant has been ${
            newStatus === "Best-Seller" ? "best seller" : "not a best seller"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isFeatured} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default ProductVariantBestSellerToggleSwitch;
